
<template>
  <div class="all">
    <div class="graph-area">
      <div class="indicators-header">
        <div v-if="conditionalDisplayGhaph">
          <b
            >{{ quantityIndicators }} {{ $t("indicadores-0") }}<br />{{
              header
            }}
          </b>
        </div>
        <div v-else>
          <b>
            {{ quantityIndicators }} {{ $t("indicadores-0") }}<br />{{
              screenIndicators
            }}
          </b>
        </div>
      </div>

      <div class="graph">
        <apexcharts
          v-if="numberOfIndicators == 1"
          :options="adherencesGraph"
          width="95%"
          height="200px"
          :series="adherencesGraph.series"
        >
        </apexcharts>
        <apexcharts
          v-if="numberOfIndicators == 2"
          :options="adherencesGraph"
          width="95%"
          height="280px"
          :series="adherencesGraph.series"
        >
        </apexcharts>
        <apexcharts
          v-if="numberOfIndicators == 3"
          :options="adherencesGraph"
          width="95%"
          height="480px"
          :series="adherencesGraph.series"
        >
        </apexcharts>
        <apexcharts
          v-if="numberOfIndicators == 4"
          :options="adherencesGraph"
          width="95%"
          height="800px"
          :series="adherencesGraph.series"
        >
        </apexcharts>
        <apexcharts
          v-if="numberOfIndicators == 5"
          :options="adherencesGraph"
          width="95%"
          height="1000px"
          :series="adherencesGraph.series"
        >
        </apexcharts>
        <apexcharts
          v-if="numberOfIndicators == 6"
          :options="adherencesGraph"
          width="95%"
          height="1200px"
          :series="adherencesGraph.series"
        >
        </apexcharts>
      </div>
      <div v-if="conditionalDisplayGhaph" class="show-all-button-column">
        <button class="show-all-button" @click="showAll">
          {{ $t("mostrar-todos") }}
        </button>
      </div>
    </div>
    <div class="legend">
      <div class="aderence-legend-symbol"></div>
      <div class="aderence-legend">{{ $t("aderencia-1") }}</div>
      <div class="treated-occurrence-legend-symbol"></div>
      <div class="treated-occurrence-legend">{{ $t("ocor-tratadas-0") }}</div>
      <div class="minimal-aderence-legend-symbol"></div>
      <div class="minimal-aderence-legend">{{ $t("aderencia-minima") }}</div>
    </div>
  </div>
</template>

  
<script>
import VueApexCharts from "vue-apexcharts";
import Mediator from "../utilites/Mediator";
import { ParseNumber } from '../../../global';

export default {
  components: {
    apexcharts: VueApexCharts,
  },

  data: function () {
    return {
      conditionalDisplayGhaph: false,
      header: "",
      screenIndicators: "",
      quantityIndicators: "",
      numberOfIndicators: 1,
      adherencesGraph: {
        chart: {
          height: 600,
          width: 10 * 100,
          type: "bar",
          toolbar: {
            show: false,
          },
          events: {},
        },

        series: [],

        yaxis: {
          labels: {
            maxWidth: 600,
            style: {
              fontSize: "13px",
              fontWeight: 700,
            },
          },
        },

        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
          line: {
            horizontal: false,
          },
        },

        legend: {
          show: false,
          showForSingleSeries: true,
          customLegendItems: [
            this.$t("aderencia-0"),
            this.$t("ocor-tratadas-1"),
            this.$t("aderencia-minima-0"),
          ],
          markers: {
            fillColors: ["#00A39F", "#FF7100", "#000"],
          },
        },

        tooltip: {
          marker: {
            show: false,
          },
        },

        colors: ["#909193"],
      },
    };
  },

  methods: {
    loadChart(data) {
      this.switch(data.length);
      this.quantityIndicators = data.length;
      data  = data.map(d => ({...d, y: ParseNumber(d.y)}))
      this.adherencesGraph.series = [
        {
          name: this.$t("aderencia-1"),
          type: "bar",
          data: data,
        },
      ];
    },

    switch(n) {
      if (n <= 5) this.numberOfIndicators = 1;
      else if (n < 11) this.numberOfIndicators = 2;
      else if (n < 21) this.numberOfIndicators = 3;
      else if (n < 31) this.numberOfIndicators = 4;
      else if (n < 41) this.numberOfIndicators = 5;
      else this.numberOfIndicators = 6;
    },

    showAll() {
      Mediator.notify("", "show-all");
      this.conditionalDisplayGhaph = false;
    },
  },

  mounted() {
    Mediator.notify(this, "init-graph-2");
  },
};
</script>

<style scoped>
.all {
  display: grid;
}
.graph-area {
  display: grid;
  grid-template-columns: 0.8fr 6fr 1fr;
}

.indicators-header {
  margin-top: 89px;
  margin-left: 50px;
  font-size: 15px;
  font-weight: 500;
}
.graph {
  min-height: 14rem;
  max-height: 4rem;
  overflow-y: auto;
  overflow-x: hidden;
}

.show-all-button-column {
  display: flex;
  justify-content: flex-end;
}
.show-all-button {
  background-color: #00a39f;
  border-radius: 4px;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  height: 40px;
  width: 130px;
  margin-right: 10%;
  margin-top: 108px;
  opacity: 1;
}

.show-all-button:hover {
  cursor: pointer;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);
  opacity: 0.8;
}

.legend {
  display: flex;
  justify-content: space-evenly;
  font-size: 12px;
  width: 360px;
  margin-top: 6px;
  margin-left: auto;
  margin-right: auto;
}

.aderence-legend {
  display: flex;
  justify-content: space-between;
}

.aderence-legend-symbol {
  background-color: #909193;
  border-radius: 2px;
  height: 15px;
  width: 15px;
}

.treated-occurrence-legend {
  display: flex;
  justify-content: space-between;
}

.treated-occurrence-legend-symbol {
  background-color: #ff7100;
  border-radius: 50%;
  height: 15px;
  width: 15px;
}

.minimal-aderence {
  display: flex;
  justify-content: space-between;
}

.minimal-aderence-legend-symbol {
  margin-top: 6px;
  background-color: #000;
  border-radius: 2 px;
  height: 7px;
  width: 15px;
}

@media only screen and (max-height: 768px) {
  .show-all-button {
    margin-top: 55px;
    font-size: 14px;
    height: 35px;
    width: 115px;
  }
  .indicators-header {
    margin-top: 55px;
    margin-left: 15px;
    font-size: 14px;
    font-weight: 400;
  }

  .graph {
    min-height: 8rem;
    max-height: 1rem;
  }
}

/* @media only screen and (min-height: 1050px) {
  .graph {
    min-height: 320px;
    max-height: 320px;
  }
  .legend {
    margin-top: 3%;
  }

  .show-all-button {
    margin-top: 86px;
  }
  .indicators-header {
    margin-top: 95px;
  }
}

@media only screen and (min-height: 1400px) {
  .graph-area {
    grid-template-columns: 1fr 4.6fr 1fr;
  }
  .graph {
    min-height: 140px;
    max-height: 160px;
  }
  .legend {
    margin-left: 40%;
    margin-top: 12px;
  }
  .show-all-button {
    margin-top: 85px;
  }
  .indicators-header {
    margin-top: 95px;
  }
  .areas-header {
    margin-top: 95px;
  }
}  */

/* @media only screen and (max-height: 900px) {
  .graph {
    min-height: 200px;
    max-height: 350px;
  }
} */
</style>